export function checkIsAssetOrAuxiliaryContent(item) {
  var type = item.type;
  return type === 'upload' || type === 'web' || type === 'zip' || type === 'scorm' || type === 'folder' || type === 'topic' || type === 'section' || type === 'event';
}
export function checkIsAsset(content) {
  return content.type === 'upload' || content.type === 'web' || content.type === 'zip' || content.type === 'scorm' || content.type === 'event';
}
export function checkIsPlaylist(item) {
  return item.type === 'playlist';
}
export function checkIsNestedPlaylist(item, _ref) {
  var parentPlaylist = _ref.parentPlaylist;
  return (item === null || item === void 0 ? void 0 : item.type) === 'playlist' && !!(parentPlaylist !== null && parentPlaylist !== void 0 && parentPlaylist.id);
}
export function checkIsSection(item) {
  return item.type === 'section';
}
export function checkIsTopic(item) {
  return item.type === 'topic';
}
export function checkIsPlaylistWithContent(item) {
  var isPlaylist = checkIsPlaylist(item);
  var isPlaylistWithContent = isPlaylist && 'content' in item && item.content !== undefined;
  return isPlaylistWithContent;
}
export function checkIsPlaylistContent(item) {
  return 'rank' in item;
}